import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PartnerConfig } from 'interfaces/partner-config';
import { getAllLsBets, getQuickBetEnabled } from 'store/selectors/betslip';
import { getPartnerConfigs } from 'store/selectors/socket';
import { getIsLoggedIn, getUser } from 'store/selectors/user-data';

export function useAccountBalanceAvailable(checker?: boolean): boolean {
  const user = useSelector(getUser);
  const allLsBets = useSelector(getAllLsBets);
  const quickBetEnabled = useSelector(getQuickBetEnabled);
  const isLoggedIn = useSelector(getIsLoggedIn);
  const partnerConfig = useSelector(getPartnerConfigs) as PartnerConfig;

  const accountBalanceAvailable = useMemo(() => {
    if (
      !isLoggedIn ||
      (!allLsBets?.length && !quickBetEnabled && !checker) ||
      !user
    ) {
      return false;
    } else {
      if (user.sport_bonus && isLoggedIn) {
        return true;
      }

      if (user.bonus_money && isLoggedIn) {
        return true;
      }

      return false;
    }
  }, [isLoggedIn, allLsBets?.length, partnerConfig, quickBetEnabled, checker]);

  return accountBalanceAvailable;
}
